/**
 * @generated SignedSource<<bcc01bf7e745ebca97b948e2d06a14a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutStripeForm_transaction$data = {
  readonly shipment: {
    readonly shippingAddress: {
      readonly country: string | null;
      readonly displayName: string | null;
      readonly zipCode: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "CheckoutStripeForm_transaction";
};
export type CheckoutStripeForm_transaction$key = {
  readonly " $data"?: CheckoutStripeForm_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutStripeForm_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutStripeForm_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Shipment",
      "kind": "LinkedField",
      "name": "shipment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "shippingAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "09a550a486ace6d197983e318351198c";

export default node;
